import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux"

import { TextInputField, Button } from '../../../helpers'

import { Tooltip } from 'primereact/tooltip'

import { raiseToast } from '../../../services/redux/reducers/toast/toast'

const ReveresManufacture = (props) => {
    const {
        isReverseManufacture,
        enteredQtyToReverse,
        uniqueCreatedMaterialIds,
        selectedCreatedMaterialId,
        reversedSmartStockMoveData,
        consumableInStockData,
        selectedWarehouseId,
        handleStockAdjForReverseManufacture,
        setReversedSmartStockMoveData,
        avlManufacturedQtyData
    } = props

    const dispatch = useDispatch()

    const [expandedIndex, setExpandedIndex] = useState(0)

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index)
    }

    const handleConfirm = () => {
        if(!enteredQtyToReverse){
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter qty to reverse', life: 3000 }))
        }
        let updatedReversedSmartStockMoveData = reversedSmartStockMoveData.flat()
        let adjustedReverseSmartStockMoves = updatedReversedSmartStockMoveData.filter(eachStockMove => eachStockMove.adjustQty && eachStockMove.adjustQty > 0)
        let isValid = true

        consumableInStockData.forEach(eachConsumableMaterial => {
            const requiredQty = eachConsumableMaterial.updatedConsumedRatio * enteredQtyToReverse
            const relatedFilteredData = adjustedReverseSmartStockMoves.filter(each => each.materialId === eachConsumableMaterial.materialId)
            const totalAdjustQty = relatedFilteredData.reduce((sum, item) => {
                return sum + (item.adjustQty ? Number(item.adjustQty) : 0)
            }, 0)

            if (Number(totalAdjustQty.toFixed(3)) < Number(requiredQty.toFixed(3))) {
                dispatch(raiseToast({ severity: 'error', detail: `Required qty is incomplete for materialId ${eachConsumableMaterial.materialId}`, life: 3000 }))
                isValid = false
            }
        })

        if (!isValid) {
            return
        }

        const positiveStockAdj = adjustedReverseSmartStockMoves.map(eachSmartStockMove => ({
            sellerPONo: parseFloat(eachSmartStockMove.sellerPODocNo),
            materialId: eachSmartStockMove.materialId,
            warehouseId: selectedWarehouseId,
            isPositiveAdjustment: true,
            adjustedQty: eachSmartStockMove.adjustQty,
            price: eachSmartStockMove.price,
            GSTRate: eachSmartStockMove.GSTRate
        }))

        const manufacturedMaterialSmartStockMoves = getSmartStockMovesBasedOnRevManufacturedQty(avlManufacturedQtyData)
        const negativeStockAdj = manufacturedMaterialSmartStockMoves.map(eachManufacturedData => {
            return {
                adjustedQty: parseFloat(eachManufacturedData.moveQty),
                isPositiveAdjustment: false,
                warehouseId: selectedWarehouseId,
                sellerPONo: eachManufacturedData.sellerPODocNo,
                materialId: selectedCreatedMaterialId
            }
        })

        const reverseStockAdjObj = [...positiveStockAdj, ...negativeStockAdj]
        handleStockAdjForReverseManufacture(reverseStockAdjObj)
    }

    const handleTextInputChange = (idx, index, eachProductItem, value) => {
        const updateReversedSmartStockMoves = [...reversedSmartStockMoveData]
        updateReversedSmartStockMoves[idx][index].adjustQty = 0

        const relatedReversedData = updateReversedSmartStockMoves.flat().filter(each => each.materialId === eachProductItem.materialId)
        const relatedConsumedMaterial = consumableInStockData.find(each => each.materialId === eachProductItem.materialId)

        const requiredQty = enteredQtyToReverse * relatedConsumedMaterial.updatedConsumedRatio
        const totalAdjustQty = relatedReversedData.reduce((sum, item, i) => {
            if (i !== index) {
                return sum + (item.adjustQty ? Number(item.adjustQty) : 0)
            }
            return sum
        }, 0)

        const remainingQty = parseFloat((requiredQty - totalAdjustQty).toFixed(3))
        if (remainingQty === 0) {
            return dispatch(raiseToast({ severity: 'error', detail: 'No remaining qty to adjust.', life: 3000 }))
        }

        let adjustedValue = value
        if (adjustedValue < 0) {
            adjustedValue = 0
        } else {
            if (remainingQty < eachProductItem.maxAdjustQty) {
                adjustedValue = adjustedValue > remainingQty ? remainingQty : adjustedValue
            } else if(parseFloat(adjustedValue) > parseFloat(eachProductItem.maxAdjustQty)){
                adjustedValue = eachProductItem.maxAdjustQty
            }
        }

        updateReversedSmartStockMoves[idx][index].adjustQty = adjustedValue

        updateReversedSmartStockMoves[idx] = updateReversedSmartStockMoves[idx].map((row, rowIndex) => {
            const otherRowTotalAdjustQty = updateReversedSmartStockMoves[idx].reduce((sum, item, i) => {
                if (i !== rowIndex) {
                    return sum + (item.adjustQty ? Number(item.adjustQty) : 0)
                }
                return sum
            }, 0)
            const rowRemainingQty = Number((requiredQty - otherRowTotalAdjustQty).toFixed(3))
            return {
                ...row,
                placeholderQty: rowRemainingQty
            }
        })

        setReversedSmartStockMoveData(updateReversedSmartStockMoves)
    }

    const getSmartStockMovesBasedOnRevManufacturedQty = (avlManufacturedQtyData) => {
        let totalQty = parseFloat(enteredQtyToReverse)
        const result = []
        avlManufacturedQtyData.forEach(eachManufacturedData => {
            console.log("eachManufacturedData", eachManufacturedData)
            if(totalQty > 0){
                if (totalQty >= parseFloat(eachManufacturedData.moveQty)){
                    const newManufacturedData = {...eachManufacturedData, moveQty: parseFloat(eachManufacturedData.moveQty)}
                    result.push(newManufacturedData)
                }
                else{
                    const newManufacturedData = {...eachManufacturedData, moveQty: totalQty}
                    result.push(newManufacturedData)
                }
            }
            totalQty -= parseFloat(eachManufacturedData.moveQty)
        }) 

        return result
    }

    const manufacturedMaterialSmartStockMoves = getSmartStockMovesBasedOnRevManufacturedQty(avlManufacturedQtyData)

    const relatedMaterialDetails = uniqueCreatedMaterialIds.find(each => each.materialId === selectedCreatedMaterialId)

    return (
        <div>
            {isReverseManufacture && (
                <div className='p-card mt-2 mb-4'>
                    <>
                        <p style={{ fontSize: '14px', fontWeight: 'bold' }}>REVERSE MANUFACTURED MATERIALS DETAILS </p>
                        <div className='p-card mt-3' style={{ width: '100%' }}>
                            <p style={{ fontSize: '12px', fontWeight: '300' }}>{relatedMaterialDetails.materialDetails}</p>
                            <table className="custom-table">
                                <thead>
                                    <tr className="reverse-manufacture-material-table-tr ">
                                        <th className="custom-th">SR</th>
                                        <th className="custom-th">Seller PO No</th>
                                        <th className="custom-th">Reverse Qty</th>
                                        <th className="custom-th">Price</th>
                                    </tr>
                                </thead>
                                {manufacturedMaterialSmartStockMoves.map((eachAvlManufactured, index) => {
                                    return (
                                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                            <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="custom-td">{index + 1}</td>
                                                <td className="custom-td">{eachAvlManufactured.sellerPODocNo}</td>
                                                <td className="custom-td">{eachAvlManufactured.moveQty}</td>
                                                <td className="custom-td">{eachAvlManufactured.price}</td>
                                            </tr>
                                        </tbody>
                                    )
                                })}
                            </table>
                        </div>
                    </>
                    <div className="hr-line" style={{ backgroundColor: "#c0c2c4" }} />
                    {(
                        <>
                            <p style={{ fontSize: '14px', fontWeight: 'bold' }}>REVERSE CONSUMED MATERIALS DETAILS</p>
                            {reversedSmartStockMoveData.map((eachSmartStockMoveList, idx) => {
                                const relatedMaterialDetail = consumableInStockData.find(eachConsumedMaterial => eachConsumedMaterial.materialId === eachSmartStockMoveList[0].materialId)
                                const isExpanded = expandedIndex === idx

                                return (
                                    <div key={idx} className='p-card mt-3' style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <p style={{ fontSize: '12px', fontWeight: '300', margin: 0 }}>
                                                {relatedMaterialDetail.materialDetails}
                                            </p>
                                            <div className={`custom-toggle-tooltip-${idx}`}>
                                                <button style={{ cursor: 'pointer', background: 'none', border: 'none', fontSize: '14px', fontWeight: 'bold' }} onClick={() => toggleExpand(idx)}>
                                                    {isExpanded ? '⬇️' : '➡️'}
                                                </button>
                                            </div>
                                            <Tooltip target={`.custom-toggle-tooltip-${idx}`} position="top" autoHide>
                                                {isExpanded ? 'Collapse' : 'Expand'}
                                            </Tooltip>

                                        </div>

                                        {isExpanded && (
                                            <table className="custom-table">
                                                <thead>
                                                    <tr className="reverse-manufacture-table-tr">
                                                        <th className="custom-th">SR</th>
                                                        <th className="custom-th">Seller PO No</th>
                                                        <th className="custom-th">Avl. Qty.</th>
                                                        <th className="custom-th">Qty Aval. To Rev.</th>
                                                        <th className="custom-th">Price</th>
                                                        <th className="custom-th">Enter Qty To Rev.</th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                                    {eachSmartStockMoveList.map((eachProductItem, index) => (
                                                        <tr className="custom-tr" key={index} style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                            <td className="custom-td" style={{ width: "12px" }}>{index + 1}</td>
                                                            <td className="custom-td" style={{ width: "100px" }}>{eachProductItem.sellerPODocNo}</td>
                                                            <td className="custom-td" style={{ width: "50px" }}>{parseFloat(eachProductItem.sellerPoQty).toFixed(3)}</td>
                                                            <td className="custom-td" style={{ width: "50px" }}>{eachProductItem.maxAdjustQty}</td>
                                                            <td className="custom-td" style={{ width: "50px" }}>{eachProductItem.price}</td>
                                                            <td className="custom-td" style={{ width: "30px", height: "50px" }}>
                                                                <TextInputField
                                                                    name={`adjustQty_${idx}_${index}`}
                                                                    placeholder={`Upto ${eachProductItem.placeholderQty}`}
                                                                    value={eachProductItem.adjustQty || ''}
                                                                    onChange={(e) => handleTextInputChange(idx, index, eachProductItem, e.target.value)}
                                                                    keyfilter="pnum"
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                )
                            })}
                        </>
                    )}

                    <div className="flex flex-row mt-4 justify-content-center">
                        <Button className="small-btn" label="confirm" onClick={handleConfirm} />
                    </div>
                </div>
            )}

        </div>
    )
}

export default ReveresManufacture